import React from 'react';
import { useTranslation } from 'react-i18next';
import { APP_STORE_URLS } from '../config/appLinks';
import { appendAttributionParams, getAttribution } from '../utils/attribution';
import { trackAppConversion } from '../utils/gtm';

/**
 * Tracked outbound CTA for App Store / Google Play / Web app.
 * Fires GA4 + Ads-ready dataLayer events before navigation.
 */
const AppCtaLink = ({
  platform = 'web',
  placement = 'unknown',
  href,
  className,
  children,
  onClick,
  ...rest
}) => {
  const { i18n } = useTranslation();
  const language = (i18n.language || 'en').split('-')[0];
  const resolvedHref = appendAttributionParams(
    href || APP_STORE_URLS[platform] || APP_STORE_URLS.web,
    getAttribution()
  );

  const handleClick = (event) => {
    trackAppConversion({
      platform,
      placement,
      language,
      destinationUrl: resolvedHref
    });

    if (typeof onClick === 'function') {
      onClick(event);
    }
  };

  return (
    <a
      href={resolvedHref}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      data-app-platform={platform}
      data-app-placement={placement}
      onClick={handleClick}
      {...rest}
    >
      {children}
    </a>
  );
};

export default AppCtaLink;
